var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3525_838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125 250C194.036 250 250 194.036 250 125C250 55.9644 194.036 0 125 0C55.9644 0 0 55.9644 0 125C0 194.036 55.9644 250 125 250Z",
    fill: "#6747ED"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.177 141.146C104.688 141.146 89.8439 126.302 89.8439 107.813C89.8439 89.3229 104.688 74.4792 123.177 74.4792C141.667 74.4792 156.511 89.3229 156.511 107.813C156.511 126.302 141.667 141.146 123.177 141.146ZM123.177 57.8125C150.781 57.8125 173.177 80.2083 173.177 107.813C173.177 135.417 150.781 157.812 123.177 157.812C95.5731 157.812 73.1772 135.417 73.1772 107.813C73.1772 80.2083 95.5731 57.8125 123.177 57.8125ZM170.834 160.417C174.219 163.802 174.219 169.01 170.834 172.135L137.5 205.469C134.115 208.854 128.906 208.854 125.781 205.469C122.396 202.083 122.396 196.875 125.781 193.75L159.115 160.417C162.24 157.031 167.709 157.031 170.834 160.417ZM190.104 66.1458C190.104 70.8333 186.459 74.4792 181.771 74.4792C177.084 74.4792 173.438 70.8333 173.438 66.1458C173.438 61.4583 177.084 57.8125 181.771 57.8125C186.198 57.8125 190.104 61.4583 190.104 66.1458Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3525_838"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrt);
export default __webpack_public_path__ + "static/media/grt.d304a61b4a0d362421487dcf90ef688e.svg";
export { ForwardRef as ReactComponent };